export default {
    billing: {
        billingDetails: 'Billing Details',
        buyMailPoints: 'Buy MailPoints',
        changeSubscription: 'Change Subscription',
    },
    client: {
        clientHistory: 'Client History',
        contact: 'Contact',
        documents: 'Documents',
        notes: 'Notes',
        sendingSettings: 'Sending Settings',
        summary: 'Summary',
    },
    documentSettings: {
        conversionSettings: 'Conversion',
        customTemplates: 'Custom Templates',
        documentApproval: 'Approval',
        documentPresets: 'Document Presets',
        extendedDataFields: 'Extended Data Fields',
        numbering: 'Numbering',
        pdfFilenameSettings: 'PDF Filename',
        tags: 'Tags',
        taxRegistrationNumber: 'TRN Display',
    },
    history: {
        documentArchive: 'Document Archive',
        downloads: 'Downloads',
        events: 'Events',
        sendingOrders: 'Sending Orders',
    },
    portal: {
        clientInbox: 'Client Inbox',
        clientInboxUsers: 'Settings',
        contactInformation: 'Contact Information',
        personalInbox: 'Personal Inbox',
    },
    team: {
        groupsAndRoles: 'Groups & Roles',
        members: 'Members',
        revoked: 'Revoked',
    },
    teamMember: {
        employeeRights: 'Employee Rights',
        groups: 'Groups',
        notifications: 'Notifications',
        overview: 'Overview',
    },
    yourCompany: {
        billingAndPlan: 'Billing & Plan',
        dataExport: 'Data Export',
        dataImport: 'Data Import',
        earlyAccess: 'Early Access',
        integrations: 'Integrations',
        settings: 'Settings',
    },
};
